var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 324,
    viewBox: "0 0 324 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame_1_svg__clip0_603_12989)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2DA3A",
    d: "M0 162h162v162H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.75 323.75a161.744 161.744 0 01-114.375-47.376A161.753 161.753 0 010 162h161.75v161.75z",
    fill: "#F68282",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 243,
    r: 40.437,
    fill: "#5ACBBC",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7563E7",
    d: "M162.01 162h162v162h-162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.75 162a161.744 161.744 0 01-47.376 114.374A161.757 161.757 0 01162 323.75V162h161.75z",
    fill: "#fff",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.01,
    cy: 243,
    r: 40.437,
    fill: "#F68282",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ACBBC",
    d: "M162 0v162H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 161.749A161.748 161.748 0 01161.75-.001V161.75L0 161.749z",
    fill: "#7563E7",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.25,
    cy: 81,
    r: 40.437,
    transform: "rotate(90 81.25 81)",
    fill: "#F2DA3A",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F68282",
    d: "M324 162H162V0h162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 0a161.75 161.75 0 01161.75 161.75H162V0z",
    fill: "#B2CBDE",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 81.501,
    r: 40.437,
    transform: "rotate(-180 243 81.501)",
    fill: "#fff",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame_1_svg__clip0_603_12989"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h324v324H0z"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgFrame1 as ReactComponent };